<mat-card class="subscriptions-body">
    <div class="settings-heading">Email Subscriptions</div>
    <p class="section-title">
        Manage which subscriptions your users can activate. Disabling subscriptions here will
        prevent emails from being sent.
    </p>
    <br />
    <div style="padding-bottom: 20px">
        <kendo-grid #grid="kendoGrid" [height]="750" class="lg-kendo-grid" [data]="gridData">
            <kendo-grid-column
                [style]="{ width: '15%' }"
                [headerStyle]="{ width: '15%' }"
                field="isInactive"
                title="Enabled"
                [width]="130"
            >
                <ng-template kendoGridCellTemplate let-record>
                    <div style="display: flex">
                        <p-checkbox
                            [(ngModel)]="record.isActive"
                            [binary]="true"
                            (onChange)="toggleTask(record)"
                            style="margin: auto"
                        />
                    </div>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column
                [style]="{ width: '25%' }"
                [headerStyle]="{ width: '25%' }"
                field="name"
                title="Subscription"
            >
            </kendo-grid-column>
            <kendo-grid-column
                [style]="{ width: '45%' }"
                [headerStyle]="{ width: '45%' }"
                field="description"
                title="Description"
            >
            </kendo-grid-column>
            <kendo-grid-column
                [style]="{ width: '15%' }"
                [headerStyle]="{ width: '15%' }"
                field="schedule"
                title="Frequency"
            >
            </kendo-grid-column>
            <kendo-grid-column
                [style]="{ width: '45%', overflow: 'visible' }"
                [headerStyle]="{ width: '45%' }"
                field="schedule"
                title="Positions"
            >
                <ng-template kendoGridCellTemplate let-record>
                    <angular2-multiselect
                        class="subscriptions-multiselect"
                        [data]="allPositions"
                        [(ngModel)]="overallPositionsSelected[record.clientSubscriptionTaskKey]"
                        [settings]="record.dropdownListSettings"
                        (onSelect)="onSelectPosition($event, record.clientSubscriptionTaskKey)"
                        (onDeSelect)="onDeselectPosition($event, record.clientSubscriptionTaskKey)"
                    >
                    </angular2-multiselect>
                </ng-template>
            </kendo-grid-column>
        </kendo-grid>
    </div>
</mat-card>
